/**
 * Idempotency keys for safe retries against backend endpoints that honor `Idempotency-Key`
 * (see backend/docs/api-idempotency.md).
 */

export function newIdempotencyKey(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** JSON POST headers including Idempotency-Key (header name is case-insensitive for fetch). */
export function checkoutJsonHeaders(idempotencyKey: string): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    'Idempotency-Key': idempotencyKey,
  };
}

export type CheckoutIdempotentStep = 'preauth' | 'create' | 'payment' | 'capture' | '3ds-auth' | '3ds-complete';

/**
 * One key per step, stable across user retries until {@link reset} (success or cart change).
 */
export class CheckoutIdempotencySession {
  private keys: Partial<Record<CheckoutIdempotentStep, string>> = {};

  key(step: CheckoutIdempotentStep): string {
    if (!this.keys[step]) {
      this.keys[step] = newIdempotencyKey();
    }
    return this.keys[step]!;
  }

  reset(): void {
    this.keys = {};
  }
}
